import { erpAxios } from '.';

const insertCosts = async (data) => {
  const res = await erpAxios.post(`/costsAndDates/costs`, data);
  return res;
};

export default insertCosts;
